import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnterpriseActionLogComponent } from './enterprise-action-log.component';


const routes: Routes = [
  { path: 'enterprise-action-log', component: EnterpriseActionLogComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnterpriseActionLogRoutingModule { }
